<ng-container *ngIf="obj_Camera?.strUrl == ''; else isStreaming ">

    <div class="card w-100 h-100">

        <!-- اطلاعات خودرو -->
        <div class="card-header">
            <strong *ngIf="obj_Camera.fullName">
                <small style="color:#1f2937">
                    {{ obj_Camera.fullName | faNum}} -
                    {{obj_Camera.channel}}
                </small>
            </strong>
        </div>

        <!-- ویدیو -->

        <div class="card-body p-0 w-100" [style.max-height]="maxHeight" style="overflow:hidden">
            <div class="w-100 h-100 d-flex justify-content-center align-items-center">
                <div class="spinner-border spinner-lg text-secondary"></div>
            </div>
        </div>

        <!-- اطلاعات خودرو -->

        <div class="card-footer">
            <p class="mb-0 text-center" *ngIf="obj_Camera.strUnitId">
                <small class="fw-bold">
                    {{ obj_Camera?.strUnitId?.split('-')[0] | faNum}}
                </small>
            </p>
        </div>
    </div>

</ng-container>

<ng-template #isStreaming>
    <video-player [tripId]="tripId" [tiChannel]="tiChannel" [ScreenShot]="ScreenShot" [expiresAt]="expiresAt"
        [src]="obj_Camera.strUrl" [obj_Cam]="obj_Camera" [isHideInfo]="isHideInfo">
    </video-player>
</ng-template>